var map = {
	"./": [
		"./src/chat/index.js",
		7
	],
	"./botpresschat": [
		"./src/chat/botpresschat.js",
		9,
		10,
		36
	],
	"./botpresschat.js": [
		"./src/chat/botpresschat.js",
		9,
		10,
		36
	],
	"./brevo": [
		"./src/chat/brevo.js",
		9,
		37
	],
	"./brevo.js": [
		"./src/chat/brevo.js",
		9,
		37
	],
	"./freshchat": [
		"./src/chat/freshchat.js",
		9,
		10,
		38
	],
	"./freshchat.js": [
		"./src/chat/freshchat.js",
		9,
		10,
		38
	],
	"./index": [
		"./src/chat/index.js",
		7
	],
	"./index.js": [
		"./src/chat/index.js",
		7
	],
	"./livechat": [
		"./src/chat/livechat.js",
		9,
		39
	],
	"./livechat.js": [
		"./src/chat/livechat.js",
		9,
		39
	],
	"./zendesk": [
		"./src/chat/zendesk.js",
		9,
		"npm.dansmaculotte",
		40
	],
	"./zendesk.js": [
		"./src/chat/zendesk.js",
		9,
		"npm.dansmaculotte",
		40
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/chat lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;